import {
  FIXED,
  MOBILE,
  EXPEDITED_FIXED,
  NORMAL_FIXED,
  IMPACT_LEVEL_1,
  IMPACT_LEVEL_2,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const approvalCommSLA = {
  [FIXED]: {
    [NORMAL_FIXED]: {
      [IMPACT_LEVEL_1]: 10,
      [IMPACT_LEVEL_2]: 10,
    },
    [EXPEDITED_FIXED]: {
      [IMPACT_LEVEL_1]: 2,
      [IMPACT_LEVEL_2]: 2,
    },
  },
  [MOBILE]: {},
};

export { approvalCommSLA };
